var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Yellow-Info-Bar",
    transform: "translate(-1379.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1379.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#007B47",
    points: "-9.9475983e-14 15.9953623 23.8776923 15.9953623 23.8776923 7.10542736e-15 -9.9475983e-14 7.10542736e-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FFB600",
    points: "-9.9475983e-14 14.0676406 9.07961538 7.99761159 -9.9475983e-14 1.92781449"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#000000",
    points: "1.77635684e-15 12.7923014 7.176 7.99763478 1.77635684e-15 3.2032"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "2.82980769 9.27536232e-05 12.3875769 6.3936 23.8778077 6.3936 23.8778077 9.27536232e-05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#F63123",
    points: "4.81077692 9.27536232e-05 12.7291615 5.31603478 23.8778538 5.31603478 23.8778538 9.27536232e-05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    points: "12.3876 9.60197101 2.83006154 15.9954783 23.8778308 15.9954783 23.8778308 9.60197101"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#02209C",
    points: "12.7290462 10.679258 4.81112308 15.9954319 23.8777385 15.9954319 23.8777385 10.679258"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaFlag);
export default __webpack_public_path__ + "static/media/SA_Flag.cbc781d976673abeac233c7bbadaa896.svg";
export { ForwardRef as ReactComponent };